'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var footerAccordions = context.getElements('.' + context.className + '_Column');

  footerAccordions.forEach(function (el) {
    el.querySelector('.' + context.className + '_Header').addEventListener('click', function (e) {
      e.preventDefault();

      el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });
}